"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncompatibleWith = exports.incompatibleSiblingsNotPresent = exports.IsNotSiblingOf = void 0;
var class_validator_1 = require("class-validator");
var isNotSiblingOf = (function () {
    function isNotSiblingOf() {
    }
    isNotSiblingOf.prototype.validate = function (value, args) {
        if ((0, class_validator_1.isDefined)(value)) {
            return this.getFailedConstraints(args).length === 0;
        }
        return false;
    };
    isNotSiblingOf.prototype.defaultMessage = function (args) {
        var siblings = this.getFailedConstraints(args);
        var exclusiveProps = __spreadArray([args.property], __read(siblings), false);
        var propsStr = exclusiveProps
            .join(', ')
            .replace(/,\s([^,]*)$/, "".concat(siblings.length > 1 ? ', or $1' : ' or $1'));
        return "Property ".concat(args.property, " is exclusive. Only one of ").concat(propsStr, " must be present.");
    };
    isNotSiblingOf.prototype.getFailedConstraints = function (args) {
        return !args ? [] : args.constraints.filter(function (prop) { return (0, class_validator_1.isDefined)(args.object[prop]); });
    };
    isNotSiblingOf = __decorate([
        (0, class_validator_1.ValidatorConstraint)({ async: false })
    ], isNotSiblingOf);
    return isNotSiblingOf;
}());
function IsNotSiblingOf(props, validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            constraints: props,
            validator: isNotSiblingOf,
        });
    };
}
exports.IsNotSiblingOf = IsNotSiblingOf;
function incompatibleSiblingsNotPresent(incompatibleSiblings) {
    return function (object, value) {
        return Boolean((0, class_validator_1.isDefined)(value) ||
            incompatibleSiblings.every(function (prop) { return !(0, class_validator_1.isDefined)(object[prop]); }));
    };
}
exports.incompatibleSiblingsNotPresent = incompatibleSiblingsNotPresent;
function IncompatibleWith(fields, validationOptions) {
    var notSibling = IsNotSiblingOf(fields, validationOptions);
    var validateIf = (0, class_validator_1.ValidateIf)(incompatibleSiblingsNotPresent(fields), validationOptions);
    return function (target, key) {
        notSibling(target, key);
        validateIf(target, key);
    };
}
exports.IncompatibleWith = IncompatibleWith;
//# sourceMappingURL=incompatible-with.js.map